var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatasetsFilter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0V18H15.5V0H0.5ZM2 1.5H14V5.25H2V1.5ZM2 6.75H14V11.25H2V6.75ZM2 12.75H14V16.5H2V12.75Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetsFilter);
export default __webpack_public_path__ + "static/media/datasets-filter.bca9cf40.svg";
export { ForwardRef as ReactComponent };